(function () {
    'use strict';

    angular
        .module('app')
        .controller('ViewItemDialog', ViewItemDialog);

    ViewItemDialog.$inject = ['DialogInstance', 'item'];

    /**
     * @ngdoc controller
     * @name ViewItemDialog
     *
     * @description
     * Dialog for showing the item
     *
     * @param {object} item - The item to be shown
     */
    function ViewItemDialog(DialogInstance, item) {
        /* jshint validthis:true */
        var vm = this;
        vm.item = item;
        vm.getItemTypeLabel = getItemTypeLabel;
        vm.close = close;

        function close() {
            DialogInstance.ok();
        }

        function getItemTypeLabel() {
            var result = vm.item.Type;

            switch (vm.item.Type) {
                case 'DocumentTemplate':
                    result = 'Document Template';
                    break;
                case 'EmailAddressCache':
                    result = 'Email Address Cache';
                    break;
                case 'EmailTemplate':
                    result = 'Email Template';
                    break;
                case 'Entity':
                    result = !_.isNil(vm.item.EntityTemplateName) ? vm.item.EntityTemplateName : 'Entity';
                    break;
                case 'EntityTemplate':
                    result = 'Entity Template';
                    break;
                case 'SMSTemplate':
                    result = 'SMS Template';
                    break;
                case 'DashboardSetting':
                    result = 'Dashboard Panel';
                    break;
                case 'WorkflowDefinition':
                    result = 'Workflow Definition';
                    break;
                case 'WorkflowInstance':
                    result = 'Workflow Instance';
                    break;
                default:
                    break;
            }

            return result;
        }
    }
})();
